import { isNil } from 'lodash-es';

/**
 * 移除物件中值為 null 或 undefined 的屬性
 * @param o - 要處理的物件
 * @returns 移除空值後的新物件
 * @example clarifyObject({ a: 1, b: null, c: undefined, d: 'test' }) // { a: 1, d: 'test' }
 */
export const clarifyObject = (o: Record<string, any>) => Object.fromEntries(
  Object.entries(o).filter(([_, v]) => !isNil(v)),
);
